import React, { createContext, useContext, useMemo, useState } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = (message, { type = "info", title } = {}) => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const toast = { id, type, title, message };
    setToasts((prev) => [...prev, toast]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3500);
  };

  const api = useMemo(
    () => ({
      show,
      success: (message, opts = {}) => show(message, { ...opts, type: "success" }),
      error: (message, opts = {}) => show(message, { ...opts, type: "error" }),
      info: (message, opts = {}) => show(message, { ...opts, type: "info" }),
    }),
    []
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="rs-toast-stack" aria-live="polite" aria-relevant="additions">
        {toasts.map((t) => (
          <div key={t.id} className={`rs-toast rs-toast--${t.type}`}>
            {t.title ? <div className="rs-toast__title">{t.title}</div> : null}
            <div className="rs-toast__message">{t.message}</div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}

